<template>
  <div class="my-card">
    <b-button
      variant="primary"
      :to="{name: 'master-category-add'}"
    >
      Tambah Kategori
    </b-button>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item :to="{ name: 'master-category-edit', params: {id: props.row.id} }">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item class="d-none" @click="openDeleteModal(props.row.id)">
                <div class="text-danger d-flex align-items-center">
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Hapus</span>
                </div>
              </b-dropdown-item>

            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      id="modal-delete"
      v-model="showDeleteModal"
      ok-only
      ok-title="Tutup"
      centered
      size="md"
      title="Konfirmasi Hapus Kategori"
      hide-footer
    >
      <div class="text-center p-3">
        <feather-icon
          icon="AlertTriangleIcon"
          size="48"
          class="text-danger mb-2"
        />
        <h5 class="text-danger font-weight-bold">
          Apakah Anda yakin?
        </h5>
        <p class="text-muted mb-2">
          Kategori yang dihapus <strong>tidak dapat dikembalikan</strong>.
        </p>
        <div class="d-flex justify-content-center mt-3">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showDeleteModal = false"
          >
            Batal
          </b-button>
          <b-button
            variant="danger"
            @click="deleteCategory"
          >
            <feather-icon
              icon="TrashIcon"
              class="mr-1"
            />
            Hapus
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem,
  BButton,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
  },
  data() {
    return {
      pageLength: 10,
      showDeleteModal: false,
      dir: false,
      columns: [
        { field: 'id', label: 'id' },
        { field: 'name', label: 'Kategori' },
        { field: 'desc', label: 'Keterangan' },
        { field: 'action', label: 'Action' },
      ],
      rows: [],
      searchTerm: '',
      DeleteId: null,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.$http.get('/category')
      .then(res => {
        this.rows = res.data.category.map(ctg => ({
          id: ctg.id,
          name: ctg.name,
          desc: ctg.desc,
        }))
      })
  },
  methods: {
    openDeleteModal(id) {
      this.DeleteId = id
      this.showDeleteModal = true
    },
    deleteCategory() {
      this.$http.delete(`/category/delete/${this.DeleteId}`)
        .then(() => {
          // Hapus data dari rows setelah berhasil
          this.rows = this.rows.filter(row => row.id !== this.DeleteId)

          // Tutup modal
          this.showDeleteModal = false

          // Reset DeleteId
          this.DeleteId = null

          // Opsional: Tampilkan notifikasi
          this.$toast.success('Kategori berhasil dihapus!')
        })
        .catch(() => {
          this.$toast.error('Gagal menghapus kategori.')
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
